
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sgho",
      function () {
        return require("private-next-pages/sgho.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sgho"])
      });
    }
  